import { render } from "./createDetail.vue?vue&type=template&id=65286812&scoped=true"
import script from "./createDetail.vue?vue&type=script&lang=ts"
export * from "./createDetail.vue?vue&type=script&lang=ts"

import "./createDetail.vue?vue&type=style&index=0&id=65286812&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65286812"

export default script